import FilterDropdown from 'components/Functional/Filters/FilterDropdown';
import { UpdatedFiltersType } from 'model/Article';

type Props = {
  filters: Array<UpdatedFiltersType>;
  loading: boolean;
  onClearFilters: (filter) => void;
  filterApply: () => void;
  onSelect: (option) => void;
  getFacets: (filter) => void;
};

const ArticleFilters = ({
  filters,
  filterApply,
  loading,
  onClearFilters,
  onSelect,
  onResetUnAppliedOptions,
  getFacets,
}: Props) => {
  return filters.map((filter) => (
    <div key={filter.name} className="d-none d-lg-block mt-4 mt-md-0 mt-lg-3">
      <FilterDropdown
        filter={filter}
        isFetching={loading}
        optionSelect={onSelect}
        onClearFilterSelection={onClearFilters}
        filterApply={filterApply}
        needAggregateCount={() => getFacets(filter.name)}
        resetUnAppliedOptions={onResetUnAppliedOptions}
      />
    </div>
  ));
};

export default ArticleFilters;
